<template>
  <span class="fs-1_3 third--text">
    {{title}}
  </span>
</template>

<script>
export default {
  name: "TextInformative",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>

</style>
